<material-navbar
  [container]="true"
  [menuPosition]="
    settings.get('vebto.navbar.defaultPosition', 'homepage-navbar')
  "
  class="login-button-accent"
>
  <div class="fab-container">
    <!-- <div class="fab shadow">
      <div class="fab-content">
        <i class="fa fa-comments-o" aria-hidden="true"></i>
      </div>
    </div>
    <div class="sub-button shadow">
      <a href="https://ig.me/m/jioshurl" target="_blank">
        <i
          
          class="fa fa-instagram"
          aria-hidden="true"
        ></i>
      </a>
    </div>
    <div class="sub-button shadow">
      <a href="https://m.me/JioShURL" target="_blank">
        <i
          class="fa fa-facebook"
          aria-hidden="true"
        ></i>
      </a>
    </div>
    <div class="sub-button shadow">
      <a
        href="https://twitter.com/messages/compose?recipient_id=1410639908738244612&text=Hi"
        target="_blank"
      >
        <i
          class="fa fa-twitter"
          aria-hidden="true"
        ></i>
      </a>
    </div>
    <div class="sub-button shadow">
      <a href="https://t.me/JioShURLBot" target="_blank">
        <i
          class="fa fa-telegram"
          aria-hidden="true"
        ></i>
      </a>
    </div>
    <div class="sub-button shadow">
      <a
        href="https://api.whatsapp.com/send/?phone=917276595716&text=Hi&type=phone_number&app_absent=0"
        target="_blank"
      >
        <i
          class="fa fa-whatsapp"
          aria-hidden="true"
        ></i>
      </a>
    </div> -->
    </div
></material-navbar>

<div class="hero header-overlay" style="background: #546ef9">
  <div
    class="background-image"
    [style.background-image]="'url(' + content.headerImage + ')'"
    [style.opacity]="content.headerImageOpacity"
  ></div>
  <svg
    viewBox="0 0 100 15"
    style="position: absolute; bottom: 0; left: 0; z-index: 2"
  >
    <path fill="#fff" opacity="0.1" d="M0 30 V15 Q30 3 60 15 V30z"></path>
    <path class="wave-fill" d="M0 30 V12 Q30 17 55 12 T100 11 V30z"></path>
  </svg>
  <div class="hero-content">

    <div class="container main-head">
      <div class="main-below">
        <div class="headd">
          <h1 class="header-title" trans>{{ content.headerTitle }}</h1>
          <p class="header-description" trans>{{ content.headerSubtitle }}</p>
          <new-link-form
            *ngIf="
              currentUser.hasPermission('links.create') &&
              settings.get('links.homepage_creation')
            "
            [content]="content"
          ></new-link-form>
          <div class="action-buttons">
            <a
              class="get-started-button"
              mat-raised-button
              color="accent"
              (click)="handleCtaClick($event, content.actions.cta1, router)"
              [href]="content.actions.cta1.action"
              *ngIf="content?.actions?.cta2?.label"
              trans
              >{{ content.actions.cta1.label }}</a
            >
            <button
              class="learn-more-button"
              mat-button
              (click)="handleCtaClick($event, content.actions.cta2, router)"
              *ngIf="content?.actions?.cta2?.label"
              trans
            >
              {{ content.actions.cta2.label }}
            </button>
          </div>
        </div>
        <div>
          <!-- <video controls autoplay loop>
            <source
              src="/client/assets/images/home-page-slider-animation.mp4"
              type="video/mp4"
            />
          </video> -->
          <img
            class="display-none"
            src="/client/assets/images/homehead-removebg-preview.png"
          />
        </div>
      </div>
    </div>
  </div>
</div>

<div class="container">
  <h1 class="question">
    What is <span class="jio">Jio</span
    ><span class="orange">Sh </span> URL?
  </h1>
  <p class="div">
    JioSh URL is an advanced URL shortener & Bio-link service that helps you to
    promote and protect your brand online & offline. We provide a variety of
    tools and features for everyone from users, website publishers, bloggers and
    other content creators - all with the aim of helping you better engage with
    your audience through the power of sharing.<br />
    JioSh URL is a platform for managing all your links. It offers solutions
    that will allow you to manage your links, thanks to which you can develop
    your business while having your links under control. JioSh also allows the
    creation of Bio Link or Link in Bio, microsites and generation of QR Codes,
    so you can combine offline and online solutions for your business growth.
  </p>
  <ad-host slot="ads.landing.top"></ad-host>
  <ul class="inline-features unstyled-list">
    <li class="inline-feature">
      <div>
        <img
        class="card-image"
          src="/client/assets/images/shorturl.png"
        />
      </div>
      <h2 trans>Short URL</h2>
      <p trans class="justify" >
        Our URL Shortener is designed to help you handle all your links in an
        easy and efficient way. With our platform, you can manage your links,
        track traffic and clicks, and see the potential of your links. With
        JioSh URL, you can get more out of your links! Every digital thing is
        visible to us in the form of a URL or link. Those who are on any digital
        platform need to deal with URLs, but many of them are very long. That's
        why a short URL is a must. JioSh URL has developed the ecosystem for all
        your URL needs.
      </p>
    </li>
    <li class="inline-feature">
      <div>
        <img
        class="card-image"
          src="/client/assets/images/biolink.png"
        />
      </div>
      <h2 trans>Bio Link</h2>
      <p trans class="justify">
        With our precise and comprehensive tracking system, you can now include
        one bio link to your main page that will access all of your social media
        platforms, videos, and other digital content with just one click. This
        is an extremely useful tool for any business that wants to increase its
        reach both online and offline. Having all of your content in one place
        makes it easy for customers or clients to connect with you and learn
        more about what you do.
      </p>
    </li>
    <li class="inline-feature">
      <div>
        <img
        class="card-image"
          src="/client/assets/images/qrc.png"
        />
      </div>
      <h2 trans>QR Code</h2>
      <p trans class="justify">
        JioSh URL's QR code generator and editing capabilities give you full
        control of how your code will look to your audience. You can customize
        colors, sizes, text, and even download your code with or without a
        background. You can also track clicks and view analytics to see how your
        QR code is performing. All of this makes it easier for you to create an
        engaging and visually appealing QR code that meets your needs. So go
        ahead and try it out today!
      </p>
    </li>
  </ul>
</div>

<ng-container *ngIf="settings.get('links.homepage_stats')">
  <div class="stats container" *ngIf="stats$ | async as stats">
    <div class="stat">
      <mat-icon svgIcon="link"></mat-icon>
      <div class="info">
        <div class="text" trans>Total Links Created</div>
        <div class="number">{{ stats.links }}</div>
      </div>
    </div>
    <div class="stat">
      <mat-icon svgIcon="mouse"></mat-icon>
      <div class="info">
        <div class="text" trans>Total Link Clicks</div>
        <div class="number">{{ stats.clicks }}</div>
      </div>
    </div>
    <div class="stat">
      <mat-icon svgIcon="person"></mat-icon>
      <div class="info">
        <div class="text" trans>Users Signed Up</div>
        <div class="number">{{ stats.users }}</div>
      </div>
    </div>
  </div>
</ng-container>

<div class="professional1">
  <div class="container">
    <div class="flex">
      <div style="flex: 1 1 auto">
        <img
          class="prof-img display-none"
          src="/client/assets/images/_Pngtree_vector_illustration_man_training_presentation_5047445-removebg-preview.png"
        />
      </div>
      <div class="management-div">
        <h1 class="solutions">Link Management Solutions</h1>
        <p class="justify">
          Jio.sh is a Link Management Platform with a URL Shortener that allows
          you to create branded short links with your own custom domain. Whether
          you are a blogger, marketer, affiliate, small or large company - here
          you will have control over all your links. All supported by an
          advanced Link Analytics system, the ability to create Link-in-bio and
          generate customizable QR codes.
        </p>
        <ul class="management-list justify">
          <h2>
            <img
            class="manage-points"
              
              src="/client/assets/images/points-removebg-preview.png"
            /><b>The Best Link Builder for Your Business! ⚡</b>
          </h2>
          <p>
            JioSh URL is perfect for businesses of all sizes - from novice
            affiliates and bloggers to small, medium, and large companies and
            corporations. We will help your business grow and provide perfect
            analytics of your physical and digital marketing. So, no matter what
            size business you have, we can help you take it to new heights!
          </p>

          <h2>
            <img
            class="manage-points"
              src="/client/assets/images/points-removebg-preview.png"
            /><b>The World's Best Pricing for You! 🌏</b>
          </h2>
          <p>
            Our world-class pricing plans are competitively priced and can be
            tailored to your needs at any time. You can also upgrade your
            subscription plan at any time. If you need help, our team is
            available 24/7. We also have the best payment gateway in your
            currency. Simply find your currency on the list and you're good to
            go!
          </p>

          <h2>
            <img
            class="manage-points"
              src="/client/assets/images/points-removebg-preview.png"
            /><b>🚨 Get help fast! 🚨</b>
          </h2>
          <p>
            Our support team is available to help you 24/7! We have advanced
            features to provide you with fast and efficient support. Our
            chatbots are deployed on Whatsapp, Telegram, and social media
            platforms like Facebook, Instagram, and Twitter. You need to
            register your request and schedule the support call.
          </p>
        </ul>
        <div>
          <button
            class="stroke-btn"

            mat-stroked-button
            (click)="pricing()"
          >
            Jio.sh Features
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="container">
  <div
    class="analy-head"
  >
    <div class="analytics-div-home">
      <h1 class="orange-head link-an-head">Link Analytics</h1>

      <h1 class="measure">
        The Most Powerful and Efficient Link Building Tool.
      </h1>
      <p class="justify tool">
        Keep track of your link performance and click-through rate to ensure
        that your links are driving the results you want. JioSh URL's extensive
        statistics and analysis of link clicks will help you identify areas for
        improvement. Perfect & advanced analytics are provided by JioSh URL,
        including country-wise and state-wise data for each link. <br />
        You could be getting links every day... every hour... or even every
        minute. You just don't know. That is what makes link building a powerful
        tool. If you are not using it, you are leaving your business in the
        dust. Whether you're a content marketer, blogger, business that needs
        more web exposure, or a marketing agency that needs to close more deals,
        a link building tool is a crucial part of your arsenal. Content
        Marketing Institute reports that more than 90% of marketers use content
        marketing as a key influence in their marketing strategy. It offers a
        great ROI. link building tool is a powerful tool that every business
        should be using.<br />
        <span style="font-weight: bold; font-size: 16px">
          There are many features available, so try it out today!</span
        >
      </p>
      <button
        class="stroke-btn"
        mat-stroked-button
        (click)="login()"
      >
        See Link Analytics Page
      </button>
    </div>
    <div>
      <img
        class="display-none build-tool-img"
        src="/client/assets/images/build-tool.png"
      />
    </div>
  </div>
</div>
<div class="professional">
  <div class="container">
    <div class="biolink1">
      <div class="biolink-div">
        <div class="vid">
          <video class="video" controls autoplay loop>
            <source
              src="/client/assets/images/WhatsApp Video 2023-01-07 at 14.40.01.mp4"
              type="video/mp4"
            />
          </video>
        </div>
      </div>
      <div class="biolink">
        <h1 class="orange-head">Bio Link</h1>

        <h1 class="create-biolink">
          Create a beautiful Bio Link page to drive traffic with
          <span class="jio">Jio</span
          ><span class="orange">Sh</span> URL
        </h1>
        <p class="justify">
          Create a microsite that is fully customizable and expresses the things
          that are important to you. Show your links and track how many clicks
          they get. Share your Bio Link on social media platforms and use a
          dedicated and customizable QR code for your Business.
        </p>
        <div>
          <a href="https://jio.sh/url" target="_blank"
            ><button
              class="stroke-btn"
              mat-stroked-button
            >
              See our Bio Link
            </button></a
          >
        </div>
        <ul class="biolink-list justify">
          <h2 >
            <img
           
               class="biolink-point"
              src="/client/assets/images/points-removebg-preview.png"
            /><b>🚗 Design your Bio Link in simple steps 💁🏻</b>
          </h2>
          <p>
            You can create personalized micro pages with links that are
            important to you, and customize the template to better suit your
            needs. This can include adding a profile picture, title,
            description, and social media profiles. You can also include other
            digital links like YouTube videos and images. If you're a music
            lover, you can even add a list of your albums. And if you're an
            online seller, you can add your store to the Bio link.
          </p>
          <h2 >
            <img
               class="biolink-point"
              src="/client/assets/images/points-removebg-preview.png"
            />
            <b>🚨 Track All Your Bio Link Click Metrics 🚨</b>
          </h2>
          <p>
            By measuring the clicks on each bio link subpage and the links
            included in a given link subpage, you can get an idea of how popular
            that page is. You can also track QR Code scan counts to see how many
            people are scanning that code.
          </p>

          <h2 >
            <img
               class="biolink-point"
              src="/client/assets/images/points-removebg-preview.png"
            />
            <b>💡 Get your ideal QR Code for your Bio Link 💡</b>
          </h2>
          <p>
            JioSh URL presents a seamless solution for generating personalized QR codes for your biolink. With effortless customization options, users can tailor their QR code design to match their preferences, resulting in a unique and visually appealing code. Once customized, the downloaded QR code can be effortlessly integrated into your biolink, enabling efficient sharing and easy access to your desired online content.
          </p>

          <h2 >
            <img
               class="biolink-point"
              src="/client/assets/images/points-removebg-preview.png"
            />
            <b>
              <img
                class="bluetick"
                src="/client/assets/images/bluetick.png"
              />
              The best Bio link service with the Blue Tick
              <img
                class="bluetick"
                src="/client/assets/images/bluetick.png"
              />
            </b>
          </h2>
          <p>
            We are providing the best Bio link service with the Blue Tick. it
            will helpful to every business to get notified by others. it's a
            unique feature for every type of Business & Website. The Bio-link
            service is the best way to show your business to other business and
            make profit by getting in touch with customers. Bio-link service
            make you save your time & helps you to grow your business.
          </p>


        </ul>
      </div>
    </div>
  </div>
</div>
<div class="container">
  <div class="qr">
    <div class="qr-div">
      <h1 class="orange-head">QR Code</h1>

      <h2 class="blast">📱 Blast your Brand into Real-World using QR Codes</h2>
      <p>
        JioSh URL offers the ability to generate and edit QR codes for every
        short link and bio link. This way, you can have complete control over
        how your QR code looks in terms of its design, making it more visually
        appealing and engaging for your audience. You can also track click count
        and grow your business in a smart way. All of this is made possible by
        our various functions that allow you to adjust sizes, colours, and text.
        You can even download your QR code without a background. So go ahead and
        create the perfect QR code for your needs!
      </p>

      <p>
        The QR code stands for "Quick Response" code. QR codes are powerful and
        compact, which makes them perfect for advertising.Especially if you make
        your QR codes visually appealing!
      </p>
      <p>
        Although having a URL on a card can be a great way to direct traffic to
        your page, QR codes are an even better choice.
      </p>
      <p>
        There are a lot of these codes and they are in just about every type of
        printed media.
      </p>
      <p>
        You can place them on the back of your business cards, on your flyers,
        and even on the packaging of your product!
      </p>
      <p>
        If you have information that you'd like to share with people locally,
        have them scan your QR codes!
      </p>
      <p>
        This will make sure they will never forget the information that you want
        to share with them.
      </p>
    </div>
    <div class="benefits">
      <h2 class="qr-bene-head" >QR Code's Benefits</h2>
      <p class="justify">
        There are many benefits to using QR codes in your marketing strategy.
        They are much easier to remember and will likely be scanned more rapidly
        than traditional URLs. QR codes are gaining in popularity among
        companies and individuals. Here are some of the benefits of using QR
        codes!
      </p>
      <p class="justify points">
        1. People can learn more about your product or service.<br />
        2. People can get to know more about your brand.<br />
        3. People can instantly gain access to your website, blog or app.<br />
        4. People can learn how to use your product or service.<br />
        5. People can share your content with friends, family and colleagues.<br />
        6. People can get access to your information anywhere and anytime.<br />
        7. QR codes are memorable and fun.<br />
        8. QR codes can help increase brand awareness and sales.<br />
        9. People can learn more about your product or service.<br />
        10. QR Codes are easily shared.<br />
        11. QR Codes can be used for marketing purposes.<br />
        12. QR Codes are artistic and eye-catching.<br />
        13. People can learn more about your product or service.<br />
        14. Customers can take advantage of special offers that may only be
        available through a QR code.<br />
        15. It's easy to get people excited about your product or service.
      </p>
    </div>

    <div>
      <img
        class="display-none qr-code-img"
        src="/client/assets/images/qrcode.png"
      />
    </div>
  </div>
</div>

<div class="professional">
  <div class="container">
    <div class="support-div">
      <div>
        <img
          class="display-none"
          height="408px"
         
          src="/client/assets/images/brand-domain.png"
        />
      </div>
      <div class="shortner-div">
        <h1 class="orange-head">We Support your Brand</h1>

        <h2 class="support-head">
          Say hello 👋 to <span class="jio">Jio</span
          ><span class="orange">.sh</span>! To create short links on
          your Brand Domain
        </h2>
        <p class="justify">
          Make your links with your brand domain to generate more clicks and
          grow your brand with JioSh URL. Check who clicks your links, on what
          devices, and from what locations. You can add any brand domain to our
          backend system in the dashboard and use all of JioSh URL's Short URL
          features on your brand domain. Please choose a suitable plan for this
          purpose. A short link in your own domain can unleash the potential of
          your links. Make your audience receive links that are friendly and
          readable. Keep your links short, but convey much more content so your
          customers can see you better.
        </p>
        <p class="justify">
          JioSh is an easy way to create short links on your domain. Here are a
          few simple steps you can take to create short links on your domain.
          First, login and go to your dashboard. Then, set a short link and pick
          a redirect to it. You can also go to your dashboard, to see how many
          unique clicks and visits your link is receiving. By doing this, you
          can create short links that are relevant to your website and are based
          on keywords you're looking to target.
        </p>
        <button
          class="stroke-btn"
          mat-stroked-button
          (click)="login()"
        >
          See Link Analytics Page
        </button>
      </div>
    </div>
  </div>
</div>

<div class="button-card">
    <div class="button-card-div">
      <button
        class="link-btn"
        mat-stroked-button
        (click)="linkManagement()"
        [ngClass]="{ toggle: showdiv1 == true }"
      >
        <i class="fa fa-link" aria-hidden="true"></i><br />
        <div class="display-none">Link Creation On Bot</div>
      </button>
      <button
        class="link-btn"
        mat-stroked-button
        (click)="multipleShortUrl()"
        [ngClass]="{ toggle: showdiv2 == true }"
      >
        <i class="fa fa-link" aria-hidden="true"></i>
        <i class="fa fa-link" aria-hidden="true"></i><br />
        <div class="display-none">Multiple Short URL</div>
      </button>
      <button
        class="link-btn"
        mat-stroked-button
        (click)="linkAnalysis()"
        [ngClass]="{ toggle: showdiv3 == true }"
      >
        <i class="fa fa-bar-chart" aria-hidden="true"></i><br />
        <div class="display-none">State-Wise Analytics</div>
      </button>
      <button
        class="link-btn"
        mat-stroked-button
        (click)="customDomain()"
        [ngClass]="{ toggle: showdiv4 == true }"
      >
        <i class="fa fa-globe" aria-hidden="true"></i><br />
        <div class="display-none">Custom Domain</div>
      </button>
      <button
        class="link-btn"
        mat-stroked-button
        (click)="teamFeatures()"
        [ngClass]="{ toggle: showdiv5 == true }"
      >
        <i class="fa fa-users" aria-hidden="true"></i><br />
        <div class="display-none">Workspaces</div>
      </button>
      <button
        class="link-btn"
        mat-stroked-button
        (click)="api()"
        [ngClass]="{ toggle: showdiv6 == true }"
      >
        <i class="fa fa-cogs" aria-hidden="true"></i><br />
        <div class="display-none">API</div>
      </button>
  </div>
</div>

<!-- <div class="container" *ngIf="showdiv1 == true">
  <div class="button-data">
    <div>
      <h1 class="orange-head">Link Creation on Bot</h1>

      <h2 class="link-creation-head">
        🔌📲 Create a short links on your favourite social media or Messenger
        app
      </h2>
      <p>
        With JioSh URL's chatbot, you can easily create and track short URLs on
        What’s App, Telegram, Facebook, Instagram, and Twitter by following
        these simple steps:
      </p>
      <p>
        1. Start by saying Hi to the JioSh URL's chatbot.<br />
        2. Follow the instructions of Register User.<br />
        3. Start creating short links & get analytics and QR codes in your
        favourite app.<br />
        4. Please Check many other info & features available on JioSh URL Bot!
        💻 📲
      </p>
      <button
        class="stroke-btn"
        mat-stroked-button
        (click)="login()"
      >
        Link Creation on Bot
      </button>
    </div>
    <div>
      <img
        class="display-none"
        height="330px"
        src="/client/assets/images/bot.png"
      />
    </div>
  </div>
</div> -->

<div class="container" *ngIf="showdiv2 == true">
  <div class="button-data">
    <div>
      <h1 class="orange-head">Multiple Short URL</h1>

      <h2 class="link-creation-head">
        Create Multiple Short URL
      </h2>
      <p>JioSh URL is an innovative platform that provides users with a unique feature allowing them to generate multiple short URLs for a single long URL. This functionality offers a range of benefits and empowers users to gather comprehensive analytics for a long URL across multiple occasions.</p>
      <p>With JioSh URL, users can create short, memorable URLs that redirect to their desired long URL. By generating multiple short URLs for a single long URL, users gain the ability to track and analyze the performance of their content or campaigns in a more granular and detailed manner.</p>
      <p>The comprehensive analytics provided by JioSh URL enable users to gather insights into the engagement and effectiveness of their long URL across various channels and instances. Users can examine metrics such as click-through rates, geographic location of the clicks, referral sources, and other relevant data points.</p>
      <p>By utilizing different short URLs for different occasions, users can better understand the impact of their long URL in different contexts. For example, if a long URL is shared on social media platforms multiple times, users can generate separate short URLs for each instance and track the engagement and reach of each individual share. This allows users to identify patterns, trends, and areas for improvement, ultimately optimizing their content strategy.</p>
      <p>The ability to obtain comprehensive analytics for a long URL on multiple occasions sets JioSh URL apart from traditional URL shortening services. It equips users with valuable data and insights to make informed decisions, refine their marketing strategies, and enhance the overall performance of their online content.</p>
      <p>Overall, JioSh URL's feature of generating multiple short URLs for a single long URL provides users with a powerful tool for tracking and analyzing the effectiveness of their content across various instances, enabling them to maximize engagement and achieve their desired outcomes.</p>
      <button
        class="stroke-btn"
        mat-stroked-button
        (click)="login()"
      >
        Create Multiple Short URL's
      </button>
    </div>
    <div>
      <img
        class="display-none"
        height="330px"
        src="/client/assets/images/multiple-links.png"
      />
    </div>
  </div>
</div>

<div class="container" *ngIf="showdiv3 == true">
  <div class="button-data">
    <div>
      <h1 class="orange-head">State-Wise Analytics</h1>

      <h2 class="link-creation-head">
        See What’s Popular on Your Website, by Country & State!
      </h2>
      <p>
        JioSh URL is an analytics tool that provides users with data that is
        more detailed and specific than other similar tools. You can track the
        location of your visitors by country and state, as well as the most
        popular content on your website. This information can be very helpful
        for marketing purposes, such as understanding what strategies work well
        for similar websites or learning from them. Additionally, JioSh URL is
        especially useful for businesses promoting their products or services
        locally or within a specific state. By inputting your website's long URL
        into JioSh URL Dashboard, you can quickly and easily access country- and
        state-specific analytics.
      </p>
      <button
        class="stroke-btn"
        mat-stroked-button
        (click)="login()"
      >
        See State-Wise Analytics
      </button>
    </div>
    <div>
      <img
        class="display-none"
        height="330px"
        src="/client/assets/images/state-wise.png"
      />
    </div>
  </div>
</div>

<div class="container" *ngIf="showdiv4 == true">
  <div class="button-data">
    <div>
      <h1 class="orange-head">Custom Domains</h1>

      <h2 class="link-creation-head">
        JIOSH URL 🔗- a platform to shorten, analyze and track links under your
        own brand
      </h2>
      <p>
        JioSh URL gives you this opportunity. You can shorten and analyze links
        under your own brand - you can add multiple custom domains and replace
        jio.sh with your own domain. It will increase your brand value, and
        you'll be able to take advantage of JioSh URL's advanced tracking and
        analytics features through the JioSh URL Dashboard. A tool that allows
        you to shorten links, track their click-through rates, and represent
        your brand.
      </p>
      <button
        class="stroke-btn"
        mat-stroked-button
        (click)="login()"
      >
        See Custom Domain Page
      </button>
    </div>
    <div>
      <img
        class="display-none"
        height="330px"
        src="/client/assets/images/domain.jpg"
      />
    </div>
  </div>
</div>

<div class="container" *ngIf="showdiv5 == true">
  <div class="button-data">
    <div>
      <h1 class="orange-head">Jio.sh Workspaces</h1>

      <h2 class="link-creation-head">
        Invite Your Team Members to Your Workspace.
      </h2>
      <p>
        Keep your links organized and under control by inviting members to join
        your own Workspace. You can manage and monitor your work more
        efficiently by assigning roles to team members. Keep your brand strong
        by having each team manage its own links and inviting its own members -
        that way you can keep track of everything more easily.
      </p>
      <button
        class="stroke-btn"
        mat-stroked-button
        (click)="login()"
      >
        See Workspaces Page
      </button>
    </div>
    <div>
      <img
        class="display-none"
        height="240px"
        src="/client/assets/images/workspace.png"
      />
    </div>
  </div>
</div>

<div class="container" *ngIf="showdiv6 == true">
  <div class="button-data">
    <div>
      <h1 class="orange-head">Jio.sh for developers - API</h1>

      <h2 class="link-creation-head">
        Now you can use Link API to manage your links more efficiently!
      </h2>
      <p>
        If you're looking for a more efficient way to manage your links,
        consider using one of our APIs. With our APIs, you can add, edit, and
        delete links as well as download click statistics. You can also add and
        edit links in your own domain. Depending on your subscription, you have
        access to several different APIs on our website. Each team you create
        has its own API key, so you can customize your link management to fit
        your needs.
      </p>
      <button
        class="stroke-btn"
        mat-stroked-button
        (click)="login()"
      >
        See API Page
      </button>
    </div>
    <div>
      <img
        class="display-none"
        height='330px'
        src="/client/assets/images/api.png"
      />
    </div>
  </div>
</div>

<div class="container">
  <div class="center"><h2>Frequently Asked Questions</h2></div>
  <div class="faq-div">
    <mat-accordion>
      <mat-expansion-panel
        (opened)="panelOpenState = true"
        (closed)="panelOpenState = false"
      >
        <mat-expansion-panel-header>
          <mat-panel-title>
            Why choose JioSh URL over other URL shorteners?
          </mat-panel-title>
        </mat-expansion-panel-header>
        <p class="faq-ans justify">
          JioSh is an all-in-one link management platform that provides a more
          advanced way to manage your links and support your brand growth. With
          JioSh, you can generate short links that are custom branded for your
          business. You can also track clicks and analytics for your links, and
          create QR codes for easy scanning.
          <br /><br />
          JioSh URL is the leading Indian platform for creating your own micro
          pages and Bio Links. JioSh URL is constantly expanding its offer in
          order to provide even better services that support your activities and
          brand.
          <br /><br />
          For more information on all features and subscription plans, please
          visit:
          <a target="_blank" href="https://jio.sh/billing/pricing"
            >https://jio.sh/billing/pricing</a
          >
        </p>
      </mat-expansion-panel>
      <mat-expansion-panel
        (opened)="panelOpenState = true"
        (closed)="panelOpenState = false"
      >
        <mat-expansion-panel-header>
          <mat-panel-title> What is a JioSh URL shortener? </mat-panel-title>
        </mat-expansion-panel-header>
        <p class="faq-ans justify">
          JioSh URL is the perfect solution for those looking to create branded
          short links and track their click statistics. With JioSh, you can
          create short links on either the
          <a href="https://jio.sh/" target="_blank">www.jio.sh </a>domain or
          your own custom domain, so you can have complete control over your
          brand. You can also use your own name or aliases as the back half of
          your short links, making them more readable to your audience and more
          likely to generate clicks.<br /><br />
          JioSh URL Shortener, or Link Shortener, is a tool that takes a long
          URL and transforms it into a shorter link that still leads to the
          original target URL. This can be helpful when you want to share a link
          but don't want it to take up too much space.
        </p>
      </mat-expansion-panel>
      <mat-expansion-panel
        (opened)="panelOpenState = true"
        (closed)="panelOpenState = false"
      >
        <mat-expansion-panel-header>
          <mat-panel-title> What is a custom URL shortener? </mat-panel-title>
        </mat-expansion-panel-header>
        <p class="faq-ans justify">
          Custom URL shorteners are a great way to increase click-through rates
          by editing short links to better suit your needs. JioSh is a custom
          URL shortener that allows for advanced editing of short links, making
          it easy to support your brand. With JioSh, you can create random short
          links or choose your own name and customize the back half of the link
          to make it more readable for your audience. Not only does JioSh URL
          allow you to change the front-half of the short link, but you can also
          create short links that will support your brand by using your own
          custom domain.
        </p>
      </mat-expansion-panel>
      <mat-expansion-panel
        (opened)="panelOpenState = true"
        (closed)="panelOpenState = false"
      >
        <mat-expansion-panel-header>
          <mat-panel-title> What is a short link?</mat-panel-title>
        </mat-expansion-panel-header>
        <p class="faq-ans justify">
          JioSh URL Shortener is a service that allows you to create shortened
          links with your own custom back-half. For example, if you have a long
          link like
          <a
            target="_blank"
            href="https://www.google.com/search?q=jiosh+url+&rlz=1C1CHZN_enIN996IN996&sxsrf=ALiCzsamqgNTixzdRNlZHt7DFIpQX_AByw%3A1671612814127&ei=jsmiY9OiB8rDz7sPx_6JkAo&ved=0ahUKEwjTofP_qor8AhXK4XMBHUd_AqIQ4dUDCA8&uact=5&oq=jiosh+url+&gs_lcp=Cgxnd3Mtd2l6LXNlcnAQAzIECCMQJzIKCAAQgAQQhwIQFDIHCAAQgAQQCjoKCAAQHhCiBBCwAzoICAAQogQQsANKBAhBGAFKBAhGGABQmwZYmwZgjQloAnAAeACAAZQBiAGUAZIBAzAuMZgBAKABAcgBA8ABAQ&sclient=gws-wiz-serp"
            >www.example.com/this-is-a-very-long-link</a
          >, you can use JioSh URL to shorten it to
          <a target="_blank" href="https://jio.sh/name1"
            >jio.sh/name1</a
          >
          and it will still redirect to the original long link. You can also
          create branded short links, which are links that use your own custom
          domain instead of the JioSh domain.
        </p>
      </mat-expansion-panel>
      <mat-expansion-panel
        (opened)="panelOpenState = true"
        (closed)="panelOpenState = false"
      >
        <mat-expansion-panel-header>
          <mat-panel-title> What is the Bio Link? </mat-panel-title>
        </mat-expansion-panel-header>
        <p class="faq-ans justify">
          Social platforms like LinkedIn, Twitter, and Instagram allow you to
          create a profile for yourself or your company. In these profiles, you
          can usually only share one clickable link. The link in the bio is the
          URL that is placed in the bio section of the social media profile. The
          Bio Link that you can generate with JioSh is a readable and editable
          micro page where you can place links important to you, add your own
          profile picture, title, description, but also many other things, such
          as videos Images, different Links.
        </p>
      </mat-expansion-panel>
      <mat-expansion-panel
        (opened)="panelOpenState = true"
        (closed)="panelOpenState = false"
      >
        <mat-expansion-panel-header>
          <mat-panel-title>
            How I get the Blue Tick Verification on my Bio Link?
          </mat-panel-title>
        </mat-expansion-panel-header>
        <p class="faq-ans justify">
          All brands and individuals Bio Link will be verified by JioSh URL and
          granted a blue tick. Verification will be conducted by JioSh Support
          Team via email, chat, or call. There are some specific criteria that
          need to be met by the user in order for the blue tick to be granted.
          Once these have been completed, the JioSh URL team will be able to
          easily grant the blue tick.
        </p>
      </mat-expansion-panel>
      <mat-expansion-panel
        (opened)="panelOpenState = true"
        (closed)="panelOpenState = false"
      >
        <mat-expansion-panel-header>
          <mat-panel-title> What is a QR code? </mat-panel-title>
        </mat-expansion-panel-header>
        <p class="faq-ans justify">
          QR codes are a quick and easy way to read information that is encoded
          into a two-dimensional, square barcode. QR codes are used in many
          printed items, such as product packaging, posters, billboards, and
          banners. You can also find QR codes in many places beyond print, such
          as on websites and in digital ads.
        </p>
      </mat-expansion-panel>

      <mat-expansion-panel
        (opened)="panelOpenState = true"
        (closed)="panelOpenState = false"
      >
        <mat-expansion-panel-header>
          <mat-panel-title>
            Can I generate and customize a QR Code for a short link in JioSh?
          </mat-panel-title>
        </mat-expansion-panel-header>
        <p class="faq-ans justify">
          You can easily generate QR codes for all your short links with JioSh
          URL, and you can also customize them to match your brand. With our
          customization options, you can change the colours, shapes, and even
          add your own logo. So, if you're tired of the boring black and white
          QR codes, JioSh URL is the perfect solution for you.
        </p>
      </mat-expansion-panel>

      <mat-expansion-panel
        (opened)="panelOpenState = true"
        (closed)="panelOpenState = false"
      >
        <mat-expansion-panel-header>
          <mat-panel-title> What is a branded short link? </mat-panel-title>
        </mat-expansion-panel-header>
        <p class="faq-ans justify">
          JioSh URL Shortener is the perfect tool for creating branded short
          links with your own custom domain. With JioSh, you can manage all your
          branded short links in one place - simply change the back-half of the
          short link to your own domain and you're good to go! You can also add
          multiple branded custom domains to create even more branded short
          links.
        </p>
      </mat-expansion-panel>
      <mat-expansion-panel
        (opened)="panelOpenState = true"
        (closed)="panelOpenState = false"
      >
        <mat-expansion-panel-header>
          <mat-panel-title
            >If you create a short link in JioSh, does it expire? How long do
            short links last in JioSh?
          </mat-panel-title>
        </mat-expansion-panel-header>
        <p class="faq-ans justify">
          The short link in JioSh does not expire. There is no limit to the
          lifespan of a short URL. You can delete the short link yourself at any
          time, or if you have set it to expire on a particular date in the
          dashboard, it will no longer redirect. So, it all depends on your
          choice and method of shortening the URL. If we feel that a link is not
          suspicious, we will keep it on our server. But if it is a suspicious
          link, JioSh will automatically delete it from the server.
        </p>
      </mat-expansion-panel>
      <mat-expansion-panel
        (opened)="panelOpenState = true"
        (closed)="panelOpenState = false"
      >
        <mat-expansion-panel-header>
          <mat-panel-title>
            How can I shorten long URLs and use JioSh URL for
            free?</mat-panel-title
          >
        </mat-expansion-panel-header>
        <p class="faq-ans justify">
          Yes, you can shorten JioSh URL links for free. However, by registering
          on the JioSh website and shortening links in your own dashboard, you
          will have more options for editing and managing the link. With JioSh
          subscription plans, you have more control over short links and access
          to features that will help you fully customize and manage your short
          links. <br />
          For more details on subscription plans, visit:
          <a target="_blank" href="https://jio.sh/billing/pricing"
            >https://jio.sh/billing/pricing</a
          >
        </p>
      </mat-expansion-panel>
      <mat-expansion-panel
        (opened)="panelOpenState = true"
        (closed)="panelOpenState = false"
      >
        <mat-expansion-panel-header>
          <mat-panel-title> Is JioSh URL free for a lifetime? </mat-panel-title>
        </mat-expansion-panel-header>
        <p class="faq-ans justify">
          JioSh offers a free plan but with limits to the number of links and
          bio-links. If you stay within the limit, then it is free for lifetime
          use. However, if you need to use more advanced features of JioSh, then
          please subscribe to one of our plans. We offer affordable plans to fit
          every budget. Please keep in mind that running a website requires
          upkeep and support. So please show your appreciation for JioSh by
          subscribing to our service.
        </p>
      </mat-expansion-panel>
      <mat-expansion-panel
        (opened)="panelOpenState = true"
        (closed)="panelOpenState = false"
      >
        <mat-expansion-panel-header>
          <mat-panel-title>
            Does JioSh URL allow you to add your own custom domains or branded
            domains?
          </mat-panel-title>
        </mat-expansion-panel-header>
        <p class="faq-ans justify">
          Yes, JioSh URL is an advanced URL shortener where you can add your own
          custom domain to use for URL shortening. You can add multiple custom
          domains of your own to use for URL shortening. Simply choose a plan
          that suits your needs. We are proud to offer the best support in the
          industry. Details on quantities are available here:<a
            target="_blank"
            href="https://jio.sh/billing/pricing"
            >https://jio.sh/billing/pricing</a
          >
        </p>
      </mat-expansion-panel>
      <mat-expansion-panel
        (opened)="panelOpenState = true"
        (closed)="panelOpenState = false"
      >
        <mat-expansion-panel-header>
          <mat-panel-title>
            What are the Link Analytics in Dashboard?
          </mat-panel-title>
        </mat-expansion-panel-header>
        <p class="faq-ans justify">
          JioSh URL has the number one link analytics platform. It allows you to
          see country-wise link count and state-wise click count. So, it is
          better for any marketing campaign to get more data. <br /><br />
          This platform is an excellent tool for collecting statistics on link
          clicks. It is an advanced tool that allows you to track clicks on
          short links simply and effectively. The graphs provided by JioSh are
          clear and easy to understand, making it a valuable asset for any
          marketing campaign.
        </p>
      </mat-expansion-panel>
      <mat-expansion-panel
        (opened)="panelOpenState = true"
        (closed)="panelOpenState = false"
      >
        <mat-expansion-panel-header>
          <mat-panel-title>
            What data can be tracked by clicking on short links?
          </mat-panel-title>
        </mat-expansion-panel-header>
        <p class="faq-ans justify">
          JioSh URL Shortener also comes with an advanced Link Analytics
          platform that allows you to track clicks on your short links. The
          analytical data that is collected when users click on your short links
          includes:<br /><br />
          <b>Number of clicks</b> - This will give you an idea of how popular
          your links are and where they are being clicked from;<br /><br />
          <b>Country & State of clicks</b> - This will let you know which
          countries your links are being clicked from the most. With its state
          wise click count data.<br /><br />
          <b>Source of clicks </b>- This will show you where your traffic is
          coming from so you can better target your audience;<br /><br />
          <b>Referrals</b> – Sources of redirects;<br /><br />
          <b>Devices</b> - The type of device from which the click originated,
          for example: tablet, phablet, mobile phone, TV with internet browsing
          application, desktop computer, console, etc.<br /><br />
          <b>Operating System (OS)</b> - Advanced link analytics enables you to
          see not only where the clicks are coming from, but also what version
          of the system they are using. This allows you to optimize your links
          for maximum efficiency.<br /><br />
          <b>Browsers</b> - The browser and browser version from which the click
          was made are shown.<br /><br />
          <b>Device Brands</b> - This table shows the brands of devices that
          were used to click on a short link, as well as the version of each
          device.<br /><br />
          <b>Geographic Location</b> - We are providing a list of countries, and
          if you click on the country, its state-wise click count will be
          visible to you. Every link clicked from any part of the world is
          recorded & provided in your dashboard.<br /><br />
          <b>Bot Click Count</b> - Bots clicking on shortened links are not
          counted in our system and will never be displayed. If you want to
          monitor clicks on shortened links coming from bots, you can do so by
          subscribing to our custom plan.
        </p>
      </mat-expansion-panel>

      <mat-expansion-panel
        (opened)="panelOpenState = true"
        (closed)="panelOpenState = false"
      >
        <mat-expansion-panel-header>
          <mat-panel-title>
            How many short URLs I can generate for my one long URL?
          </mat-panel-title>
        </mat-expansion-panel-header>
        <p class="faq-ans justify">Unlimited. Yes Unlimited, JioSh URL stands out with its unique feature of generating unlimited short URLs for a single long URL. </p>
        <p class="faq-ans justify">This distinctive capability sets it apart from other URL shorteners in the market.</p>
        <p class="faq-ans justify">With JioSh URL, users have the convenience of creating numerous shortened links for their desired destination. </p>
        <p class="faq-ans justify">This flexibility opens up a wide range of possibilities for sharing and tracking multiple campaigns, promotions, or content variations without limitations. </p>
        <p class="faq-ans justify">It empowers users to optimize their online presence efficiently and effectively. </p>
        <p class="faq-ans justify">Experience the convenience and freedom of JioSh URL's unparalleled feature, unmatched by any other service.</p>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</div>

<div
  class="container center url-head-div"
>
  <div><h1 class="url-shortener">URL Shortener & Bio Link Builder</h1></div>
  <p class="bottom-txt">
    JioSh URL is a URL shortener & Bio Link Builder - a great tool for easily
    managing short links & Bio Links. With JioSh, you can create short, branded
    links that support the development of your brand and your business. Bio
    Links are a cool feature that allows you to explore different aspects of
    your website.<br />
    <span style="font-weight: bold"
      >So why wait? Click the button below to Sign Up / Login now!</span
    >
  </p>
  <div class="bottom-btns">
    <a class="btn" [routerLink]="['/login']" mat-flat-button>
      Login
    </a>
    <a class="btn" [routerLink]="['/register']" mat-flat-button>
      Sign Up
    </a>
  </div>
</div>

<app-footer class="container"></app-footer>
